(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6636],{

/***/ 46636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LocoAi; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/styleguide/Homepage/Sections/LocoAi/loco-ai.module.scss
var loco_ai_module = __webpack_require__(99582);
var loco_ai_module_default = /*#__PURE__*/__webpack_require__.n(loco_ai_module);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./store/selectors/user.js
var user = __webpack_require__(15433);
// EXTERNAL MODULE: ./lib/routes.js
var routes = __webpack_require__(7158);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var utilities_system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/styleguide/Homepage/Sections/LocoAi/LocoAi.tsx












var AuthenticationModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5808), __webpack_require__.e(9161), __webpack_require__.e(8246), __webpack_require__.e(6743)]).then(__webpack_require__.bind(__webpack_require__, 93418));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93418)
            ];
        }
    },
    ssr: false
});
var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    }
});
var LocoAi = function() {
    var router = (0,next_router.useRouter)();
    var isAuthenticated = (0,es/* useSelector */.v9)(user/* selectIsAuthenticated */.vN);
    var onCtaClick = function() {
        var storageKeyExists = false;
        if ((0,utilities_system/* storageAvailable */.oZ)("localStorage")) {
            var storageKey = (0,utilities_system/* getWithExpiry */.jE)(constants/* constants.localStorageKey.aiIntro */._G.localStorageKey.aiIntro);
            storageKeyExists = !!storageKey;
        }
        if (isAuthenticated && storageKeyExists) {
            router.push(routes/* ROUTES.locoAiSearchPage.url */.Z.locoAiSearchPage.url);
        } else {
            esm/* default.show */.ZP.show(AuthenticationModal, {
                initialStatus: constants/* STATUS_AI_INTRO */.uR
            }).then(function() {
                router.push(routes/* ROUTES.locoAiSearchPage.url */.Z.locoAiSearchPage.url);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (loco_ai_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            type: "button",
            className: (loco_ai_module_default()).background,
            onClick: onCtaClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (loco_ai_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (loco_ai_module_default()).small,
                            children: [
                                "Powered by ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "LocoAI"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: "AI-powered search meets car leasing"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Not sure of the right car for you? AI-powered search makes finding your perfect car effortless."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (loco_ai_module_default()).button,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                    name: "Sparkles",
                                    size: system/* Size.Medium */.$u.Medium
                                }),
                                "Try it"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (loco_ai_module_default()).image,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/homepage/ai-foreground.png"),
                            alt: "Luis Loco",
                            height: 452,
                            width: 524
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (loco_ai_module_default()).mask,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/homepage/luis-mask.png"),
                                alt: "Luis Loco",
                                height: 450,
                                width: 450
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/styleguide/Homepage/Sections/LocoAi/index.ts



/***/ }),

/***/ 99582:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"loco-ai_content__RvUbT","small":"loco-ai_small__pxCZw","button":"loco-ai_button__ZwCcM","image":"loco-ai_image__3QXVk","mask":"loco-ai_mask__yXz9Y","container":"loco-ai_container__xRocC","background":"loco-ai_background__9KAHP","phAnimation":"loco-ai_phAnimation__gVS4v"};

/***/ })

}]);